// @ts-expect-error https://webpack.js.org/guides/public-path/#on-the-fly
__webpack_public_path__ =
  window.PUBLIC_STATIC_HOST + process.env.NX_PUBLIC_STATIC_PATH;
